export const media = {
  purchase: {
    imageTitle: "購入して閲覧しますか？",
    videoTitle: "購入して再生しますか？",
    imageDescription: "ポイントを消費して画像を閲覧します。",
    videoDescription: "ポイントを消費して動画を再生します。",
    point: (args: { point: string | number }) => `${args.point}pt`,
    confirm: "購入する",
  },
} as const;
